import { MenuLink } from '../../models/navigation/menu-link.model';
import { Right } from '../../models/Rights.enum';

export const SIDEBAR_STRUCTURE: MenuLink[] = [
    {
        id: 'balanceOutstanding',
        label: 'A payer',
        url: '/balance-outstanding',
        svg: '/assets/images/nav-a-payer',
        accessRights: [Right.Payment, Right.Cart]
    },
    {
        id: 'billAsset',
        label: 'Factures',
        url: '/bill-asset',
        svg: '/assets/images/nav-factures',
        accessRights: [Right.Payment]
    },
    {
        id: 'extractAccount',
        label: 'Extrait comptable',
        url: '/extract-account',
        svg: '/assets/images/nav-extrait-comptable',
        accessRights: [Right.AccountExtract]
    },
    {
        id: 'paymentMeans',
        label: 'Moyens de paiement',
        url: '/payment-means',
        svg: '/assets/images/nav-moyens-paiement',
        accessRights: [Right.Payment]
    }
];
